export default __webpack_public_path__ + "static/media/CZECH REPUBLIC.335a89be.png";